import React, { useEffect, useState } from "react";
import { Table, Card, Col, Row } from "react-bootstrap";
import { Link,useParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import { Modal } from "react-bootstrap";
import Header from "../../components/Header";
import "./DashboardCustomer2.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';


 
const DashboardCustomer2 = () => {
  const [loading,setLoading] = useState(true);
  const { id } = useParams();

  const [inputs,setInputs] = useState({id:'',name:'',customers_id:'',user_name:'',email:'',mobile:'',image:'',payment_setup:'',dob:'',street_name:'',city:'',state:'',zip_code:''});


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const [show2, setShow2] = useState(false);
  
  const handleClose2 = () => setShow2(false);

  const [couponmodal,setCouponmodal] = useState({});

  const [show3, setShow3] = useState(false);
  //const handleShow3 = () => setShow3(true);

  const handleShow3 = (val) => {
    setCouponmodal(val);
    setShow3(true);
  }

  const handleClose3 = () => setShow3(false);

  const [isMobile, setIsMobile] = useState(false);
  const [prAccordionOpen, setprAccordionOpen] = useState(false);
  const [cpAccordionOpen, setcpAccordionOpen] = useState(false);
  const [emAccordionOpen, setemAccordionOpen] = useState(false);
  const [payAccordionOpen, setPayAccordionOpen] = useState(false);

  const [customerfavrec,setCustomerfavrec] = useState([]);
  const [customerfav,setCustomerfav] = useState([]);
  const [favlinks, setFavlinks] = useState([]);
  const [favperpage, setFavperpage] = useState(10);
  const [favtotalrec, setFavtotalrec] = useState(0);
  const [keyword, setKeyword] = useState('');
  const [sortOrder, setSortOrder] = useState("asc");

  
  const [customerord,setCustomerord] = useState([]);
  const [ordlinks, setOrdlinks] = useState([]);
  const [ordperpage, setOrdperpage] = useState(10);
  const [ordtotalrec, setOrdtotalrec] = useState(0);
  const [keywordord, setKeywordord] = useState('');
  const [sortOrderord, setSortOrderord] = useState("asc");

  const [customercou,setCustomercou] = useState([]);
  const [coulinks, setCoulinks] = useState([]);
  const [couperpage, setCouperpage] = useState(10);
  const [coutotalrec, setCoutotalrec] = useState(0);  
  const [keywordcou, setKeywordcou] = useState('');
  const [sortOrdercou, setSortOrdercou] = useState("asc");

  const [customernot,setCustomernot] = useState([]);
  const [notlinks, setNotlinks] = useState([]);
  const [notperpage, setNotperpage] = useState(10);
  const [nottotalrec, setNottotalrec] = useState(0); 
  const [keywordnot, setKeywordnot] = useState('');
  const [sortOrdernot, setSortOrdernot] = useState("asc");

  const [customerfeed,setCustomerfeed] = useState([]);
  const [feedlinks, setFeedlinks] = useState([]);
  const [feedperpage, setFeedperpage] = useState(10);
  const [feedtotalrec, setFeedtotalrec] = useState(0);
  const [keywordfeed, setKeywordfeed] = useState('');
  const [sortOrderfeed, setSortOrderfeed] = useState("asc");


  /*const handlenotRowsChange = (e) => {
    setnotRowsPerPage(parseInt(e.target.value));
    setnotCurrentPage(1);
  };*/

  const [activeTab, setActiveTab] = useState('Favorite Stores');

  const tabHeaderNames = {
    "Favorite Stores": "Customer Favorite Stores",
    "Order History": "Customer Order History",
    "Coupon Box": "Customer Coupon Box",
    "Notification": "Customer Notifications",
    "Feedback": "Customer Feedback",
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "Favorite Stores":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <Card.Title className="d-none d-md-block">Favorite Stores</Card.Title>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Join Date</th>
                    <th>Merchant</th>
                    <th>Category</th>
                    <th>Sub Category</th>
                    <th>Order History</th>
                  </tr>
                </thead>
                <tbody>
                  {customerfav.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.join_date}</td>
                      <td><Link to={process.env.REACT_APP_BASE_URL + "merchant-subscription/"+item.store_id}>{item.store_name}</Link></td>
                      <td>{item.category_name}</td>
                      <td>{item.subcategory_name}</td>
                      <td className="ref ffgfgf" onClick={() => handleShow(item.order_array)} style={{ cursor: "pointer", textDecorationLine: "underline" }}>Invoice/Receipt</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 d-md-none">
              <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                  <div className="input-group">
                    <div className="input-group-text border-end-0">
                      <img
                        src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                        alt="Search Icon"
                        className="img-fluid"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search"
                      value={keyword}
                      onChange={handleInputChangeauto}
                    />
                  </div>
                </div>
                <button type="button" className="sloti" onClick={handleSort}>
                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2"/>
                    Sort {sortOrder === "asc" ? "(A-Z)" : "(Z-A)"}
                </button>
              </div>
            </div>

            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setPayAccordionOpen(!payAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Favorite Stores</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (payAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || payAccordionOpen) && (
              <>
                <div className="d-md-none mb-3 ev-mobilex kovha">
                  {customerfav.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      <div className="d-flex justify-content-between align-items-center fir mb-2">
                        <div className="joily d-flex"><div className="date">{item.join_date}</div></div>
                        <div className="markiu"><Link to="#" onClick={() => handleShow(item.order_array)}>Invoice/Receipt</Link></div>
                      </div>

                      <div className="erroo mb-1"><Link to={process.env.REACT_APP_BASE_URL + "merchant-subscription/"+item.store_id}>{item.store_name}</Link></div>

                      <div className="phony">{item.category_name} - {item.subcategory_name}</div>
                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={favperpage}
                      onChange={handlefavRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>

                  {favtotalrec > 0 && (
                        <nav>
                          <ul className="pagination pagination-sm mb-0">

                              {favlinks.map((link, index) => {
                                var label = link.label;
                            if (label.includes("Previous")) label = "<";
                            if (label.includes("Next")) label = ">";

                            return (
                              <>
                                <li className={`page-item ${link.active ? "active" : ""}`}>
                                  <button
                                    className={`page-link ${!link.url ? "disabled" : ""}`}
                                    onClick={() => {
                                      if (link.url) {
                                        const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                        handleFavPageChange(pageNumber);
                                      }
                                    }}
                                    
                                  >
                                    {label}
                                  </button>
                                </li>
                                </>
                                );
                              })}
                          </ul>
                        </nav>
                        )}
                </div>
              </>
            )}
          </Card>
        </div>;

      case "Order History":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <Card.Title className="d-none d-md-block">Order History</Card.Title>

            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Date</th>
                    <th>Merchant</th>
                    <th>Invoice/Receipt #</th>
                    <th>Payment Method</th>
                    <th>Employee ID #</th>
                  </tr>
                </thead>
                <tbody>
                  {customerord.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.date}</td>
                      <td>{item.store_name}</td>
                      <td><Link to={process.env.REACT_APP_BASE_URL + "custmss-receipts/" + item.id+"/"+id}>{item.order_number}</Link></td>
                      <td>{item.payment_method}</td>
                      <td className="ref"><Link to={process.env.REACT_APP_BASE_URL + "dashboard-sales-vp-of-sales"} className="text-decoration-none">{item.emp_name ? item.emp_name : '-'}</Link></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 d-md-none">
              <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                  <div className="input-group">
                    <div className="input-group-text border-end-0">
                      <img
                        src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                        alt="Search Icon"
                        className="img-fluid"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search"
                      value={keywordord}
                      onChange={handleInputChangeautoord}
                    />
                  </div>
                </div>
                <button type="button" className="sloti" onClick={handleSortord}>
                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2"/>
                    Sort {sortOrderord === "asc" ? "(A-Z)" : "(Z-A)"}
                </button>
              </div>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setemAccordionOpen(!emAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Order History</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (emAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || emAccordionOpen) && (
              <>
                <div className="d-md-none mb-3 ev-mobilex kovha">
                  {customerord.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      {/* Top row: Join date and Active tag */}
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="date">{item.date}</div>
                        <div className="date me-0"><Link to={process.env.REACT_APP_BASE_URL + "custmss-receipts/" + item.id+"/"+id}>Invoice# {item.order_number}</Link></div>
                      </div>

                      <div className="erroo d-flex gap-2 align-items-center mb-1">
                        {item.store_name}
                        <div key={index}>
                           {item.payment_method}
                        </div>
                      </div>

                      <div className="row ojuxi">
                        <div className="col-6">
                          <h2>Employee</h2>
                          <h3>{item.emp_name ? item.emp_name : '-'}</h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={ordperpage}
                      onChange={handleordRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>

                  {ordtotalrec > 0 && (
                        <nav>
                          <ul className="pagination pagination-sm mb-0">

                              {ordlinks.map((link, index) => {
                                var label = link.label;
                            if (label.includes("Previous")) label = "<";
                            if (label.includes("Next")) label = ">";

                            return (
                              <>
                                <li className={`page-item ${link.active ? "active" : ""}`}>
                                  <button
                                    className={`page-link ${!link.url ? "disabled" : ""}`}
                                    onClick={() => {
                                      if (link.url) {
                                        const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                        handleOrdPageChange(pageNumber);
                                      }
                                    }}
                                    
                                  >
                                    {label}
                                  </button>
                                </li>
                                </>
                                );
                              })}
                          </ul>
                        </nav>
                        )}
                </div>
              </>
            )}
          </Card>
        </div>;

      case "Coupon Box":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <Card.Title className="d-none d-md-block">Coupon Box</Card.Title>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Date</th>
                    <th>Expiration Date</th>
                    <th>Merchant</th>
                    <th>Coupon Name</th>
                    <th>Description</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {customercou.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.start_date}</td>
                      <td>{item.end_date}</td>
                      <td>{item.store_name}</td>
                      <td onClick={() => handleShow3(item)} style={{ cursor: "pointer", textDecorationLine: "underline" }}>{item.coupon_name}</td>
                      <td>{item.description}</td>
                      <td className="ref">{item.status_name}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 d-md-none">
              <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                  <div className="input-group">
                    <div className="input-group-text border-end-0">
                      <img
                        src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                        alt="Search Icon"
                        className="img-fluid"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search"
                      value={keywordcou}
                      onChange={handleInputChangeautocou}
                    />
                  </div>
                </div>
                <button type="button" className="sloti" onClick={handleSortcou}>
                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2"/>
                    Sort {sortOrdercou === "asc" ? "(A-Z)" : "(Z-A)"}
                </button>
              </div>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setprAccordionOpen(!prAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Coupon Box</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (prAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || prAccordionOpen) && (
              <>
                <div className="d-md-none ev-mobilex omci">
                  {customercou.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >

                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="date">{item.start_date}</div>
                        <div className={`me-0 ${item.status_name === 'Expired' ? 'expired-status' : 'active-status'}`}>{item.status_name}</div>
                      </div>

                      <div className="mb-1">
                        <div className="jox34ily" onClick={() => handleShow3(item)} style={{ cursor: "pointer", textDecorationLine: "underline" }}>{item.coupon_name}</div>
                      </div>

                      <div className="d-flex align-items-center justify-content-between">
                        <div className="jox341">{item.description}</div>
                        <div className="jox342">{item.end_date} - Expiration</div>
                      </div>

                    </div>
                  ))}
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={couperpage}
                      onChange={handlecouRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>

                  {coutotalrec > 0 && (
                        <nav>
                          <ul className="pagination pagination-sm mb-0">

                              {coulinks.map((link, index) => {
                                var label = link.label;
                            if (label.includes("Previous")) label = "<";
                            if (label.includes("Next")) label = ">";

                            return (
                              <>
                                <li className={`page-item ${link.active ? "active" : ""}`}>
                                  <button
                                    className={`page-link ${!link.url ? "disabled" : ""}`}
                                    onClick={() => {
                                      if (link.url) {
                                        const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                        handleCouPageChange(pageNumber);
                                      }
                                    }}
                                    
                                  >
                                    {label}
                                  </button>
                                </li>
                                </>
                                );
                              })}
                          </ul>
                        </nav>
                        )}
                </div>
              </>
            )}
          </Card>
        </div>;

      case "Notification":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <Card.Title className="d-none d-md-block mb-2">Notification History</Card.Title>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Date</th>
                    <th>Merchant</th>
                    <th>Notification</th>
                    <th>Content</th>
                  </tr>
                </thead>
                <tbody>
                  {customernot.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.time}</td>
                      <td>{item.store_name}</td>
                      <td>{item.title}</td>
                      <td className="ref"><div dangerouslySetInnerHTML={{ __html: item.body }} /></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 d-md-none">
              <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                  <div className="input-group">
                    <div className="input-group-text border-end-0">
                      <img
                        src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                        alt="Search Icon"
                        className="img-fluid"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search"
                      value={keywordnot}
                      onChange={handleInputChangeautonot}
                    />
                  </div>
                </div>
                <button type="button" className="sloti" onClick={handleSortnot}>
                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2"/>
                    Sort {sortOrdernot === "asc" ? "(A-Z)" : "(Z-A)"}
                </button>
              </div>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setcpAccordionOpen(!cpAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Notification History</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (cpAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || cpAccordionOpen) && (
              <>
                <div className="d-md-none ev-mobilex omci">
                  {customernot.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >

                      <div className="date mb-3">{item.time}</div>

                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="jox34ily">{item.title}</div>
                        <div className="date">- {item.store_name}</div>
                      </div>

                      <div className="kojuu"><div dangerouslySetInnerHTML={{ __html: item.body }} /></div>

                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={notperpage}
                      onChange={handlenotRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>

                  {nottotalrec > 0 && (
                        <nav>
                          <ul className="pagination pagination-sm mb-0">

                              {notlinks.map((link, index) => {
                                var label = link.label;
                            if (label.includes("Previous")) label = "<";
                            if (label.includes("Next")) label = ">";

                            return (
                              <>
                                <li className={`page-item ${link.active ? "active" : ""}`}>
                                  <button
                                    className={`page-link ${!link.url ? "disabled" : ""}`}
                                    onClick={() => {
                                      if (link.url) {
                                        const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                        handleNotPageChange(pageNumber);
                                      }
                                    }}
                                    
                                  >
                                    {label}
                                  </button>
                                </li>
                                </>
                                );
                              })}
                          </ul>
                        </nav>
                        )}
                </div>
              </>
            )}
          </Card>
        </div>;

      case "Feedback":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <Card.Title className="d-none d-md-block mb-2">Feedback</Card.Title>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Date</th>
                    <th>Feedback/Complaints</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {customerfeed.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.date}</td>
                      <td>{item.message}</td>
                      <td className="ref">{item.action ? item.action : "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 d-md-none">
              <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                  <div className="input-group">
                    <div className="input-group-text border-end-0">
                      <img
                        src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                        alt="Search Icon"
                        className="img-fluid"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search"
                      value={keywordfeed}
                      onChange={handleInputChangeautofeed}
                    />
                  </div>
                </div>
                <button type="button" className="sloti" onClick={handleSortfeed}>
                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2"/>
                    Sort {sortOrderfeed === "asc" ? "(A-Z)" : "(Z-A)"}
                </button>
              </div>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setcpAccordionOpen(!cpAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Feedback</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (cpAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || cpAccordionOpen) && (
              <>
                <div className="d-md-none ev-mobilex omci">
                  {customerfeed.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      <div className="joxily mb-3">{item.date}</div>
                      <div className="jox34ily">{item.message}</div>

                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={feedperpage}
                      onChange={handlefeedRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>

                  {feedtotalrec > 0 && (
                        <nav>
                          <ul className="pagination pagination-sm mb-0">

                              {feedlinks.map((link, index) => {
                                var label = link.label;
                            if (label.includes("Previous")) label = "<";
                            if (label.includes("Next")) label = ">";

                            return (
                              <>
                                <li className={`page-item ${link.active ? "active" : ""}`}>
                                  <button
                                    className={`page-link ${!link.url ? "disabled" : ""}`}
                                    onClick={() => {
                                      if (link.url) {
                                        const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                        handleFeedPageChange(pageNumber);
                                      }
                                    }}
                                    
                                  >
                                    {label}
                                  </button>
                                </li>
                                </>
                                );
                              })}
                          </ul>
                        </nav>
                        )}
                </div>
              </>
            )}
          </Card>
        </div>;

      default:
        return null;
    }
  };

  useEffect(() => {
    document.title = `Dashboard-Merchants-profile | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";

    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    API.post('backoffice_customer_detail',formData)
      .then(response => {
      if(response.data.status === 0){
        
      }else{
         setInputs(
          {
            id:response.data.data.id,
            name:response.data.data.name,
            customers_id:response.data.data.customers_id,
            user_name:response.data.data.user_name,
            email:response.data.data.email,
            mobile:response.data.data.mobile,
            image:response.data.data.image,
            payment_setup:response.data.data.payment_setup,
            dob:response.data.data.dob,
            street_name:response.data.data.street_name,
            city:response.data.data.city,
            state:response.data.data.state,
            zip_code:response.data.data.zip_code,
          });
      }                  
    }).catch(error => {
       
    });


    let formData1 = new FormData(); 
      formData1.append('token', localStorage.getItem("token"));
      formData1.append('id', id);
      formData1.append('per_page', 10);
      formData1.append('page', 1);
      API.post('backoffice_customer_fav_store',formData1)
        .then(response => {
        if(response.data.status === 0){
          setLoading(false); 
        }else{
           setLoading(false);
           setCustomerfav(response.data.data.data);
           setFavlinks(response.data.data.links);
           setFavtotalrec(response.data.data.total);
        }                  
      }).catch(error => {
         setLoading(false);
      });

    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [id]);

const setGetActiveTab = (key) => {
  setActiveTab(key);
  if(key==='Favorite Stores')
  {
      let formData = new FormData(); 
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_customer_fav_store',formData)
        .then(response => {
        if(response.data.status === 0){
          setLoading(false); 
        }else{
           setLoading(false);
           setCustomerfav(response.data.data.data);
           setFavlinks(response.data.data.links);
           setFavtotalrec(response.data.data.total);
        }                  
      }).catch(error => {
         setLoading(false);
      });
  }else if(key==="Order History"){
    let formData = new FormData(); 
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_customer_order',formData)
        .then(response => {
        if(response.data.status === 0){
          setLoading(false); 
        }else{
           setLoading(false);
           setCustomerord(response.data.data.data);
           setOrdlinks(response.data.data.links);
           setOrdtotalrec(response.data.data.total);
        }                  
      }).catch(error => {
         setLoading(false);
      });
  }else if(key==="Coupon Box")
  {
     let formData = new FormData(); 
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_customer_coupon',formData)
        .then(response => {
        if(response.data.status === 0){
          setLoading(false); 
        }else{
           setLoading(false);
           setCustomercou(response.data.data);
           setCoulinks(response.data.data.links);
           setCoutotalrec(response.data.data.total);
        }                  
      }).catch(error => {
         setLoading(false);
      });
  }else if(key==="Notification")
  {
     let formData = new FormData(); 
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_customer_notification',formData)
        .then(response => {
        if(response.data.status === 0){
          setLoading(false); 
        }else{
           setLoading(false);
           setCustomernot(response.data.data.data);
           setNotlinks(response.data.data.links);
           setNottotalrec(response.data.data.total);
        }                  
      }).catch(error => {
         setLoading(false);
      });
  }else if(key==="Feedback")
  {
     let formData = new FormData(); 
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_customer_service_feedback',formData)
        .then(response => {
        if(response.data.status === 0){
          setLoading(false); 
        }else{
           setLoading(false);
           setCustomerfeed(response.data.data.data);
           setFeedlinks(response.data.data.links);
           setFeedtotalrec(response.data.data.total);
        }                  
      }).catch(error => {
         setLoading(false);
      });
  }
}
const handlefavRowsChange = (e) => {
    setLoading(true);
    var perpage=parseInt(e.target.value);
    setFavperpage(perpage);

    let formData = new FormData(); 
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', perpage);
      formData.append('page', 1);
      formData.append('order_by', sortOrder);
      formData.append('keyword', keyword);
    API.post('backoffice_customer_fav_store',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomerfav(response.data.data.data);
         setFavlinks(response.data.data.links);
         setFavtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };

const handleInputChangeauto = (event) => {
    var keyword=event.target.value;
    setKeyword(keyword);
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', favperpage);
    formData.append('page', 1);
    formData.append('order_by', sortOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_customer_fav_store',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomerfav(response.data.data.data);
         setFavlinks(response.data.data.links);
         setFavtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
}

const handleSort = () => {
    setLoading(true); 
    var ascdesc=sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(ascdesc);
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', favperpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', keyword);
    API.post('backoffice_customer_fav_store',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomerfav(response.data.data.data);
         setFavlinks(response.data.data.links);
         setFavtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };

  const handleFavPageChange = (page) => {
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', favperpage);
    formData.append('page', page);
    formData.append('order_by', sortOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_customer_fav_store',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomerfav(response.data.data.data);
         setFavlinks(response.data.data.links);
         setFavtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
const handleordRowsChange = (e) => {
    setLoading(true);
    var perpage=parseInt(e.target.value);
    setOrdperpage(perpage);

    let formData = new FormData(); 
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', perpage);
      formData.append('page', 1);
      formData.append('order_by', sortOrderord);
      formData.append('keyword', keywordord);
    API.post('backoffice_customer_order',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomerord(response.data.data.data);
         setOrdlinks(response.data.data.links);
         setOrdtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };

  const handleSortord = () => {
    setLoading(true); 
    var ascdesc=sortOrderord === "asc" ? "desc" : "asc";
    setSortOrderord(ascdesc);
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', ordperpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', keywordord);
    API.post('backoffice_customer_order',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
        setCustomerord(response.data.data.data);
         setOrdlinks(response.data.data.links);
         setOrdtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
  const handleInputChangeautoord = (event) => {
    var keyword=event.target.value;
    setKeywordord(keyword);
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', ordperpage);
    formData.append('page', 1);
    formData.append('order_by', sortOrderord);
    formData.append('keyword', keyword);
    API.post('backoffice_customer_order',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomerord(response.data.data.data);
         setOrdlinks(response.data.data.links);
         setOrdtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
}
  const handleOrdPageChange = (page) => {
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', ordperpage);
    formData.append('page', page);
    formData.append('order_by', sortOrderord);
    formData.append('keyword', keywordord);
    API.post('backoffice_customer_order',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomerord(response.data.data.data);
         setOrdlinks(response.data.data.links);
         setOrdtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
  const handlecouRowsChange = (e) => {
    setLoading(true);
    var perpage=parseInt(e.target.value);
    setCouperpage(perpage);

    let formData = new FormData(); 
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', perpage);
      formData.append('page', 1);
      formData.append('order_by', sortOrdercou);
      formData.append('keyword', keywordcou);
    API.post('backoffice_customer_coupon',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomercou(response.data.data);
         setCoulinks(response.data.data.links);
         setCoutotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
  const handleInputChangeautocou = (event) => {
    var keyword=event.target.value;
    setKeywordcou(keyword);
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', couperpage);
    formData.append('page', 1);
    formData.append('order_by', sortOrdercou);
    formData.append('keyword', keyword);
    API.post('backoffice_customer_coupon',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomercou(response.data.data);
         setCoulinks(response.data.data.links);
         setCoutotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
}
const handleSortcou = () => {
    setLoading(true); 
    var ascdesc=sortOrdercou === "asc" ? "desc" : "asc";
    setSortOrdercou(ascdesc);
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', couperpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', keywordcou);
    API.post('backoffice_customer_coupon',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
        setCustomercou(response.data.data);
         setCoulinks(response.data.data.links);
         setCoutotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
  const handleCouPageChange = (page) => {
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', favperpage);
    formData.append('page', page);
    formData.append('order_by', sortOrdercou);
    formData.append('keyword', keywordcou);
    API.post('backoffice_customer_coupon',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomercou(response.data.data);
         setCoulinks(response.data.data.links);
         setCoutotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
  const handlenotRowsChange = (e) => {
    setLoading(true);
    var perpage=parseInt(e.target.value);
    setNotperpage(perpage);

    let formData = new FormData(); 
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', perpage);
      formData.append('page', 1);
      formData.append('order_by', sortOrdernot);
      formData.append('keyword', keywordnot);
    API.post('backoffice_customer_notification',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomernot(response.data.data.data);
         setNotlinks(response.data.data.links);
         setNottotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
  const handleInputChangeautonot = (event) => {
    var keyword=event.target.value;
    setKeywordnot(keyword);
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', notperpage);
    formData.append('page', 1);
    formData.append('order_by', sortOrdernot);
    formData.append('keyword', keyword);
    API.post('backoffice_customer_notification',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomernot(response.data.data.data);
         setNotlinks(response.data.data.links);
         setNottotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
}
const handleSortnot = () => {
    setLoading(true); 
    var ascdesc=sortOrdernot === "asc" ? "desc" : "asc";
    setSortOrdernot(ascdesc);
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', notperpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', keywordnot);
    API.post('backoffice_customer_notification',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
        setCustomernot(response.data.data.data);
         setNotlinks(response.data.data.links);
         setNottotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };

  const handleNotPageChange = (page) => {
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', notperpage);
    formData.append('page', page);
    formData.append('order_by', sortOrdernot);
    formData.append('keyword', keywordnot);
    API.post('backoffice_customer_notification',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomernot(response.data.data.data);
         setNotlinks(response.data.data.links);
         setNottotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
  const handlefeedRowsChange = (e) => {
    setLoading(true);
    var perpage=parseInt(e.target.value);
    setFeedperpage(perpage);
    let formData = new FormData(); 
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', perpage);
      formData.append('page', 1);
      formData.append('order_by', sortOrderfeed);
      formData.append('keyword', keywordfeed);
    API.post('backoffice_customer_service_feedback',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomerfeed(response.data.data.data);
         setFeedlinks(response.data.data.links);
         setFeedtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
  const handleInputChangeautofeed = (event) => {
    var keyword=event.target.value;
    setKeywordfeed(keyword);
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', feedperpage);
    formData.append('page', 1);
    formData.append('order_by', sortOrderfeed);
    formData.append('keyword', keyword);
    API.post('backoffice_customer_service_feedback',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomerfeed(response.data.data.data);
         setFeedlinks(response.data.data.links);
         setFeedtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
}
const handleSortfeed = () => {
    setLoading(true); 
    var ascdesc=sortOrderfeed === "asc" ? "desc" : "asc";
    
    setSortOrderfeed(ascdesc);
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', feedperpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', keywordfeed);
    API.post('backoffice_customer_service_feedback',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
        setCustomerfeed(response.data.data.data);
         setFeedlinks(response.data.data.links);
         setFeedtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
  const handleFeedPageChange = (page) => {
    let formData = new FormData(); 
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', feedperpage);
    formData.append('page', page);
    formData.append('order_by', sortOrderfeed);
    formData.append('keyword', keywordfeed);
    API.post('backoffice_customer_service_feedback',formData)
      .then(response => {
      if(response.data.status === 0){
        setLoading(false); 
      }else{
         setLoading(false);
         setCustomerfeed(response.data.data.data);
         setFeedlinks(response.data.data.links);
         setFeedtotalrec(response.data.data.total);
      }                  
    }).catch(error => {
       setLoading(false);
    });
  };
const handleShow = (val) => {
  setCustomerfavrec(val);
    setShow(true);
}

const getCoupontype = (val,discount_percentage,minimum_purchase_amount,item_name_buy,product_item_name,buy_qty,get_qty) => {
  var type='';
  if(val==='Buy & Get')
  {
    type='Buy  '+buy_qty+' '+item_name_buy+' and Get '+get_qty+' '+product_item_name+' free of Charge';
  }else if(val==='Discount Offer'){
    type=discount_percentage+'% discount when purchase over $'+minimum_purchase_amount;
  }else{
    type=val;
  }
  return type;
}


  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header tabHeaderName={tabHeaderNames[activeTab]} />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12">
                    <h1>Customer Profile</h1>
                    <div className="vnfro shadow-md-none">
                      <div className="d-flex align-items-center gap-3 mb-4 kjuk">
                        {/* Profile Image */}
                        <div className="leki">
                          <img
                            src={inputs.image}
                            alt="Profile"
                            className="img-fluid"
                          />
                        </div>

                        {/* Store Info */}
                        <div className="infea fgfr ott2">
                          <p>Customer Name</p>
                          <h5>{inputs.name}</h5>
                          <div className="ids">ID #: {inputs.customers_id}</div>
                          <div className="date">Username: {inputs.user_name}</div>
                        </div>
                      </div>

                      {/* desktop */}
                      <div className="row mt-3 d-none d-md-flex">
                        <div className="col-md-6">
                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Phone Number</div>
                            <div className="col-6 latly">{inputs.mobile}</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Address</div>
                            <div className="col-6 latly">{ [inputs.city, inputs.state, inputs.zip_code].filter(Boolean).length > 0
          ? [inputs.city, inputs.state, inputs.zip_code].filter(Boolean).join(', ')
          : '-' }</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Payment Setup</div>
                            <div className="col-6 latly">{inputs.payment_setup}</div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Email</div>
                            <div className="col-6 latly"><Link to={process.env.REACT_APP_BASE_URL + ''} className="table-link">{inputs.email}</Link></div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">DOB</div>
                            <div className="col-6 latly">{inputs.dob}</div>
                          </div>
                        </div>
                      </div>

                      {/* Mobile */}
                      <div className="row mt-3 d-md-none">
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Phone Number</div>
                          <div className="latly">{inputs.mobile}</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Email</div>
                          <div className="latly"><Link to={process.env.REACT_APP_BASE_URL + ''} className="table-link  text-decoration-none">{inputs.email}</Link></div>
                        </div>

                        <div className="col-md-4 col-12 mb-3">
                          <div className="text-start tatly">Address</div>
                          <div className="latly">{inputs.street_name}</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">DOB</div>
                          <div className="latly">{inputs.dob}</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Payment Setup</div>
                          <div className="latly">{inputs.payment_setup}</div>
                        </div>
                      </div>

                      {/* Footer Tabs (Nav Tabs Style) */}
                      <ul className="nav nav-tabs mt-4 d-none d-md-flex gap-2">
                        {[
                          { key: "Favorite Stores", label: "Favorite Stores" },
                          { key: "Order History", label: "Order History" },
                          { key: "Coupon Box", label: "Coupon Box" },
                          { key: "Notification", label: "Notification" },
                          { key: "Feedback", label: "Feedback" },
                        ].map((tab) => (
                          <li className="nav-item" key={tab.key}>
                            <button
                              className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                              onClick={() => setGetActiveTab(tab.key)}
                            >
                              {tab.label}
                            </button>
                          </li>
                        ))}
                      </ul>

                      {/* Footer Monile (Nav Tabs Style) */}
                      <div className="d-md-none overflow-auto mt-4">
                        <ul className="nav nav-tabs flex-nowrap text-nowrap">
                          {[
                            { key: "Favorite Stores", label: "Favorite Stores" },
                            { key: "Order History", label: "Order History" },
                            { key: "Coupon Box", label: "Coupon Box" },
                            { key: "Notification", label: "Notification" },
                            { key: "Feedback", label: "Feedback" },
                          ].map((tab) => (
                            <li className="nav-item" key={tab.key}>
                              <button
                                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                                onClick={() => setGetActiveTab(tab.key)}
                              >
                                {tab.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 gytf">{renderTabContent()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal centered show={show} onHide={handleClose} className="ps-0">
        <Modal.Body className="p-0">
          <Col md={12} xs={12}>
            <div className="col-12 holisti">
              <Card className="h-100">
                <div className="table-ro">
                  <Table
                    responsive
                    className="table-no-last-border mb-0"
                  >
                    <thead className="table">
                      <tr className="custom-header">
                        <th className="lft">Date</th>
                        <th>Receipt #</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customerfavrec.map((item, index) => (
                        <tr key={index}>
                          <td>{item.date}</td>
                          <td><Link to={process.env.REACT_APP_BASE_URL + "custmss-receipts/" + item.id+"/"+id}>{item.order_number}</Link></td>
                          <td className="ref">{item.amount}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card>
            </div>
          </Col>
        </Modal.Body>
      </Modal>

      <Modal show={show2} onHide={handleClose2} className="popupwrngcnt">
        <Modal.Header closeButton>
          <h3 className="mdlttltxt">Coupon</h3>
        </Modal.Header>

        <Modal.Body>
          <Col md={12} xs={12} className="ppinpt">
            <Col className="mb-3 main-copn">
              <Row className="mx-0 third-copn mb-2">
                <Col className="align-self-end text-white col copn-text text-end mb-5 px-5">
                  <h5 className="text-dark">return visit coupon</h5>
                  <p className="text-dark">10% discount when purchase over $100</p>
                  <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                  <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                </Col>
              </Row>

              {/* <Row className="mx-0 four-copn ">
                      <Col className="align-self-end text-dark col copn-text text-end">
                        <h5 className="text-dark">return visit coupon</h5>
                        <p className="text-dark">10% discount when purchase over $100</p>
                        <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                        <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                      </Col>
                    </Row> */}

              {/* <Row className="mx-0 five-copn justify-content-center ">
                      <Col md={6} xs={8} className="align-self-center text-dark col copn-text col-6 ">
                        <h5 className="text-dark">return visit coupon</h5>
                        <p className="text-dark">10% discount when purchase over $100</p>
                        <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                        <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                      </Col>
                    </Row> */}

              {/* <Row className="mx-0 six-copn justify-content-center ">
                      <Col md={6} xs={8} className="align-self-center text-dark col copn-text col-6 ">
                        <h5 className="text-dark">return visit coupon</h5>
                        <p className="text-dark">10% discount when purchase over $100</p>
                        <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                        <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                      </Col>
                    </Row> */}

              {/* <Row className="mx-0 seven-copn justify-content-end ">
                      <Col md={6} xs={8} className="align-self-center text-white col copn-text text-end col-6 mt-5">
                        <h5 className="">return visit coupon</h5>
                        <p>10% discount when purchase over $100</p>
                        <p>We miss you, please come back soon and enjoy the discount</p>
                        <p>Return Before : <span>28/08/2025</span> </p>
                      </Col>
                    </Row> */}

              {/* <Row className="mx-0 eight-copn justify-content-center">
                      <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                        <h5 className="text-dark">return visit coupon</h5>
                        <p className="text-dark">10% discount when purchase over $100</p>
                        <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                        <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                      </Col>
                    </Row> */}

              {/* <Row className="mx-0 nine-copn justify-content-center">
                      <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                        <h5 className="text-dark">return visit coupon</h5>
                        <p className="text-dark">10% discount when purchase over $100</p>
                        <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                        <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                      </Col>
                    </Row> */}

              {/* <Row className="mx-0 ten-copn justify-content-center">
                      <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                        <h5 className="text-dark">return visit coupon</h5>
                        <p className="text-dark">10% discount when purchase over $100</p>
                        <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                        <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                      </Col>
                    </Row> */}

              {/* <Row className="mx-0 eleven-copn justify-content-center">
                      <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                        <h5 className="text-dark">return visit coupon</h5>
                        <p className="text-dark">10% discount when purchase over $100</p>
                        <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                        <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                      </Col>
                    </Row> */}
            </Col>
          </Col>
        </Modal.Body>
      </Modal>

      <Modal show={show3} onHide={handleClose3} className="popupwrngcnt">
        <Modal.Header closeButton>
          <h3 className="mdlttltxt">Coupon</h3>
        </Modal.Header>

        <Modal.Body>
          <Col md={12} xs={12} className="ppinpt">
            <Col className="mb-3 main-copn">
              {(() => {
                  if (couponmodal.image==='3') {
                    return (<Row className="mx-0 third-copn mb-2">
                            <Col className="align-self-end text-white col copn-text text-end mb-5 px-5">
                              <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                              <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                              <p className="text-dark">{getCoupontype(couponmodal.coupon_type,couponmodal.discount_percentage,couponmodal.minimum_purchase_amount,couponmodal.item_name_buy,couponmodal.product_item_name,couponmodal.buy_quantity,couponmodal.get_quantity)}</p>
                              <p className="text-dark">{couponmodal.description}</p>
                              {couponmodal.return_befor ==='' ? (
                                <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> &nbsp;&nbsp;End Date :<span>{couponmodal.end_date}</span> </p>
                              ) : (
                                <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                              )}
                            </Col>
                          </Row>)
                  }else if (couponmodal.image==='4') {

                    return (<Col className="mb-3 main-copn">
                            {(() => {
                          if (couponmodal.coupon_type==='Welcome coupon'){
                            return (<Row className="mx-0 four-copn ">
                               <Col className="align-self-end text-dark col copn-text text-end">
                              <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                                <p className="text-dark">{couponmodal.discount_percentage}% for all new members joining your membership has been set up</p>
                               </Col>
                              </Row>)
                            }else{
                              return (<Row className="mx-0 four-copn ">
                               <Col className="align-self-end text-dark col copn-text text-end">
                              <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                              <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                                <p className="text-dark">{getCoupontype(couponmodal.coupon_type,couponmodal.discount_percentage,couponmodal.minimum_purchase_amount,couponmodal.item_name_buy,couponmodal.product_item_name,couponmodal.buy_quantity,couponmodal.get_quantity)}</p>
                                <p className="text-dark">{couponmodal.description}</p>
                                {couponmodal.return_befor ==='' ? (
                                  <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> &nbsp;&nbsp;End Date :<span>{couponmodal.end_date}</span> </p>
                                ) : (
                                  <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                                )}
                               </Col>
                              </Row>)
                            }                   
                          })()} 
                          </Col>)
                  }else if (couponmodal.image==='5') {
                    return (<Row className="mx-0 five-copn justify-content-center ">
                            <Col md={6} xs={8} className="align-self-center text-dark col copn-text col-6 ">
                              <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                              <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                              <p className="text-dark">{getCoupontype(couponmodal.coupon_type,couponmodal.discount_percentage,couponmodal.minimum_purchase_amount,couponmodal.item_name_buy,couponmodal.product_item_name,couponmodal.buy_quantity,couponmodal.get_quantity)}</p>
                              <p className="text-dark">{couponmodal.description}</p>
                              {couponmodal.return_befor ==='' ? (
                                <>
                                <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                                <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                                </>
                              ) : (
                                  <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                              )}
                            </Col>
                          </Row>)
                  }else if (couponmodal.image==='6') {
                    return (<Row className="mx-0 six-copn justify-content-center ">
                        <Col md={6} xs={8} className="align-self-center text-dark col copn-text col-6 ">
                          <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                          <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                          <p className="text-dark">{getCoupontype(couponmodal.coupon_type,couponmodal.discount_percentage,couponmodal.minimum_purchase_amount,couponmodal.item_name_buy,couponmodal.product_item_name,couponmodal.buy_quantity,couponmodal.get_quantity)}</p>
                          <p className="text-dark">{couponmodal.description}</p>
                          {couponmodal.return_befor ==='' ? (
                            <>
                            <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                            <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                            </>
                          ) : (
                              <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                          )}
                        </Col>
                      </Row>)
                  }else if (couponmodal.image==='7') {
                    return (<Row className="mx-0 seven-copn justify-content-end ">
                      <Col md={6} xs={8} className="align-self-center text-white col copn-text text-end col-6 mt-5">
                        <h5 className="">{couponmodal.coupon_name}</h5>
                        <p>Welcome to {couponmodal.store_name}</p>
                          <p>{getCoupontype(couponmodal.coupon_type,couponmodal.discount_percentage,couponmodal.minimum_purchase_amount,couponmodal.item_name_buy,couponmodal.product_item_name,couponmodal.buy_quantity,couponmodal.get_quantity)}</p>
                        <p>{couponmodal.description}</p>
                        {couponmodal.return_befor ==='' ? (
                          <>
                          <p>Start Date : <span>{couponmodal.start_date}</span> </p>
                          <p>End Date :<span>{couponmodal.end_date}</span> </p>
                          </>
                        ) : (
                            <p>Return Before : <span>{couponmodal.return_befor}</span> </p>
                        )}
                      </Col>
                    </Row>)
                  }else if (couponmodal.image==='8') {
                    return (<Row className="mx-0 eight-copn justify-content-center">
                        <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                          <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                          <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                          <p className="text-dark">{getCoupontype(couponmodal.coupon_type,couponmodal.discount_percentage,couponmodal.minimum_purchase_amount,couponmodal.item_name_buy,couponmodal.product_item_name,couponmodal.buy_quantity,couponmodal.get_quantity)}</p>
                          <p className="text-dark">{couponmodal.description}</p>
                          {couponmodal.return_befor ==='' ? (
                            <>
                            <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                            <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                            </>
                          ) : (
                              <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                          )}
                        </Col>
                      </Row>)
                  }else if (couponmodal.image==='9') {
                    return (<Row className="mx-0 nine-copn justify-content-center">
                          <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                            <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                            <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                            <p className="text-dark">{getCoupontype(couponmodal.coupon_type,couponmodal.discount_percentage,couponmodal.minimum_purchase_amount,couponmodal.item_name_buy,couponmodal.product_item_name,couponmodal.buy_quantity,couponmodal.get_quantity)}</p>
                            <p className="text-dark">{couponmodal.description}</p>
                            {couponmodal.return_befor ==='' ? (
                              <>
                              <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                              <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                              </>
                            ) : (
                                <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                            )}
                          </Col>
                        </Row>)
                  }else if (couponmodal.image==='10') {
                    return (<Row className="mx-0 ten-copn justify-content-center">
                        <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                          <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                          <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                          <p className="text-dark">{getCoupontype(couponmodal.coupon_type,couponmodal.discount_percentage,couponmodal.minimum_purchase_amount,couponmodal.item_name_buy,couponmodal.product_item_name,couponmodal.buy_quantity,couponmodal.get_quantity)}</p>
                          <p className="text-dark">{couponmodal.description}</p>
                          {couponmodal.return_befor ==='' ? (
                            <>
                            <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                            <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                            </>
                          ) : (
                              <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                          )}
                        </Col>
                      </Row>)
                  }else if (couponmodal.image==='11') {
                    return (<Row className="mx-0 eleven-copn justify-content-center">
                        <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                          <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                          <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                          <p className="text-dark">{getCoupontype(couponmodal.coupon_type,couponmodal.discount_percentage,couponmodal.minimum_purchase_amount,couponmodal.item_name_buy,couponmodal.product_item_name,couponmodal.buy_quantity,couponmodal.get_quantity)}</p>
                          <p className="text-dark">{couponmodal.description}</p>
                          {couponmodal.return_befor ==='' ? (
                            <>
                            <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                            <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                            </>
                          ) : (
                              <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                          )}
                        </Col>
                      </Row>)
                  }                            
              })()}
            </Col>
          </Col>
        </Modal.Body>
      </Modal>
      {loading && (
       <div className="loadingClass">
        <img src={loader} alt="loader"/>
      </div>
       )}
    </>
  );
};

export default DashboardCustomer2;